/**
 * Dung lượng dạng người đọc được — dùng chung cho đính kèm, trang Files và
 * khối dung lượng ở Tổng quan (APM-FILES-b/c). Cơ số 1024, một chữ số thập
 * phân từ MB trở lên: "1,2 GB" đọc được, "1234567 B" thì không.
 */
export function humanSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 ** 2) return `${Math.round(bytes / 1024)} KB`;
  if (bytes < 1024 ** 3) return `${(bytes / 1024 ** 2).toFixed(1)} MB`;
  return `${(bytes / 1024 ** 3).toFixed(1)} GB`;
}
